import React from 'react';
import { useDrop } from 'react-dnd';
import { Box, Text } from 'grommet';
import DraggableAvailableField from './available-field';
import { dragTypes, dropPositions } from './drag-utils';

const BetweenFieldTarget = ({ canEdit, column, dropPosition, onDrop }) => {
  const [{ isOverCurrent }, drop] = useDrop(
    () => ({
      accept: [dragTypes.AVAILABLE_FIELD],
      canDrop: () => canEdit,
      drop: (item, monitor) => {
        if (monitor.didDrop()) {
          //nested component already handled the drop
          return;
        }
        onDrop(item, column, dropPosition);
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
      })
    }),
    [canEdit, column, dropPosition, onDrop]
  );

  return (
    <section
      ref={drop}
      style={{
        height: '100px',
        width: '8px',
        zIndex: 2,
        backgroundColor: isOverCurrent ? '#428bca' : 'transparent'
      }}
    ></section>
  );
};

BetweenFieldTarget.displayName = 'BetweenFieldTarget';

const ReportCanvas = ({
  columns,
  onRemoveColumn,
  canEdit,
  onDrop
}) => {
  const [, drop] = useDrop(
    () => ({
      accept: [dragTypes.AVAILABLE_FIELD],
      canDrop: () => canEdit,
      drop: (item, monitor) => {
        if (monitor.didDrop()) {
          //nested component already handled the drop
          return;
        }
        onDrop(item);
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
      })
    }),
    [canEdit, onDrop]
  );

  return (
    <section ref={drop} style={{ display: 'flex', width: '100%' }}>
      <Box
        direction='row'
        height='100px'
        fill='horizontal'
        overflow={{ horizontal: 'auto' }}
      >
        {columns.length === 0 ? (
          <Box flex fill justify='center' align='center'>
            <Text size='large' color='dark-4'>
              Drop Metrics Here
            </Text>
          </Box>
        ) : (
          columns.map(c => {
            return (
              <Box
                direction='row'
                align='center'
                key={c.property}
                flex={{ shrink: 0 }}
              >
                <BetweenFieldTarget
                  canEdit={canEdit}
                  column={c}
                  dropPosition={dropPositions.BEFORE}
                  onDrop={onDrop}
                />
                <DraggableAvailableField
                  column={c}
                  key={c.name}
                  onRemove={() => onRemoveColumn(c)}
                  width='130px'
                />
                <BetweenFieldTarget
                  canEdit={canEdit}
                  column={c}
                  dropPosition={dropPositions.AFTER}
                  onDrop={onDrop}
                />
              </Box>
            );
          })
        )}
      </Box>
    </section>
  );
};

ReportCanvas.displayName = 'ReportCanvas';

export default ReportCanvas;
